import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["JobCard"] */ "/home/runner/work/web/web/src/components/JobCard.tsx");
